import React from 'react';
import { trackEvent } from './MetaPixel';
interface CTAButtonProps {
  text: string;
  isCheckout?: boolean;
  className?: string;
  onClick?: () => void;
}
export function CTAButton({
  text,
  isCheckout = false,
  className = '',
  onClick
}: CTAButtonProps) {
  const baseStyles = 'flex items-center justify-center w-full min-h-[52px] bg-orange-500 hover:bg-orange-600 text-white font-bold rounded-xl px-6 py-3 transition-all active:scale-95 shadow-lg shadow-orange-500/30';
  if (isCheckout) {
    const handleCheckout = () => {
      trackEvent('InitiateCheckout', {
        content_name: text
      });
      if (onClick) onClick();
    };
    return <a href="https://biologiafemenina.com.ar/checkouts/cn/hWNAZSgw69FMqj8K5JzSARhS/en-ar?_r=AQABnlLqQ012_A3hL8PvkCwsiXgReYZ5ojjVujWohyp1z2E" className={`${baseStyles} ${className}`} onClick={handleCheckout} data-id="element-39">
        {text}
      </a>;
  }
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    trackEvent('ViewContent', {
      content_name: text
    });
    if (onClick) onClick();
    const target = document.getElementById('elegir-plan');
    if (target) {
      target.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <button onClick={handleClick} className={`${baseStyles} ${className}`} data-id="element-40">
      {text}
    </button>;
}